import React from 'react'
import Tooltip from 'components/tooltip'

export default ({ text, tooltip }) => {
    return (
      <div className="live-subblock">
        <div className="live-mark live-mark--not-padded">
          <span className="live__mark">{text}</span>
          <Tooltip content={tooltip}>
            <span className="question" />
          </Tooltip>
        </div>
      </div>
    )
  }